import MoveToFolderType from '../store/schema/MoveToFolderType';

/**
 * Returns a map of folder name to count of folders with same display name
 * @param folders - list of folders
 */
export default function getFolderNameToCountMap(folders: MoveToFolderType[]): any {
    let folderNameCountMap: { [key: string]: number } = {};
    folders.map(item => {
        let displayName = item.displayName.toLowerCase();
        if (folderNameCountMap[displayName]) {
            folderNameCountMap[displayName]++;
        } else {
            folderNameCountMap[displayName] = 1;
        }
    });

    return folderNameCountMap;
}
